import React, { Component } from 'react';
import { Container } from 'commonStyles';
import { HeaderWrapper, Logo, HeaderInner } from './HeaderComponentStyles';
import { APPLICATION_PATH, MYBIZ_DEFAULT_LOGOS, MYBIZ_LOGO_IMAGES } from 'AppConstants';

export default class Header extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<HeaderWrapper>
				<Container>
					<HeaderInner justify='space-between' align='center'>
						<a href={'/' + APPLICATION_PATH}><Logo {...(MYBIZ_LOGO_IMAGES.BY_MMT || MYBIZ_DEFAULT_LOGOS.BY_MMT)} /></a>
					</HeaderInner>
				</Container>
			</HeaderWrapper>
		);
	}
}
